import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {LinkToPageOwnProps, LinkToPageStateProps} from './interface'
import {LinkToPage as LinkToPagePresentation} from './link-to-page'

const mapRuntime = ({baseUrl, pageUrl, queryParams}: AppProps): LinkToPageStateProps => ({
  baseUrl,
  pageUrl,
  queryParams,
})

export const LinkToPage = connect<LinkToPageOwnProps, LinkToPageStateProps>(mapRuntime)(LinkToPagePresentation)
